import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 20px;
  display: flex;
  gap: 20px;
  flex-direction: column;
`;

export const StyledHeader = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)}
`;

export const StyledSubHeader = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  font-weight: 600;
  margin-bottom: 10px;
`;

export const StyledSubDescription = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;

export const StyledSubSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DividerContainer = styled.div`
  padding: 0 20px;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3;
  margin-right: 20px;
`;

export const RightSide = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;
